/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExperienceProfessionnelleFichierGridDto
 */
export interface ExperienceProfessionnelleFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleFichierGridDto
     */
    idexperienceProfessionnelleFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof ExperienceProfessionnelleFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExperienceProfessionnelleFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExperienceProfessionnelleFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ExperienceProfessionnelleFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the ExperienceProfessionnelleFichierGridDto interface.
 */
export function instanceOfExperienceProfessionnelleFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExperienceProfessionnelleFichierGridDtoFromJSON(json: any): ExperienceProfessionnelleFichierGridDto {
    return ExperienceProfessionnelleFichierGridDtoFromJSONTyped(json, false);
}

export function ExperienceProfessionnelleFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceProfessionnelleFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idexperienceProfessionnelleFichier': !exists(json, 'idexperienceProfessionnelleFichier') ? undefined : json['idexperienceProfessionnelleFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function ExperienceProfessionnelleFichierGridDtoToJSON(value?: ExperienceProfessionnelleFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idexperienceProfessionnelleFichier': value.idexperienceProfessionnelleFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

